import React from 'react'
import { DeleteIcon } from '@chakra-ui/icons'
import { VStack, Input, Button, IconButton } from '@chakra-ui/react'

import {
  Card,
  Form,
  FieldList,
  FieldListItem,
  FormField,
  FormFieldArray,
  ModalController
} from 'components'

import {
  QuestionPickModal,
  QuestionListGroup,
  QuestionListGroupItem
} from 'modules/questions/components'
import { SectorDataSelect } from 'modules/sector'

import { DimensionDataTabs } from '../containers'

export const FormEditForm = React.forwardRef(({ data, onSubmit, isLoading, ...props }, ref) => (
  <Form ref={ref} data={data} onSubmit={onSubmit} isLoading={isLoading}>
    <VStack align='stretch'>
      <Card>
        <FieldList>
          <FieldListItem isRequired label='Nome'>
            <FormField name='name'>
              <Input type='text' />
            </FormField>
          </FieldListItem>

          <FieldListItem isRequired label='Setor'>
            <FormField name='sector.id'>
              <SectorDataSelect />
            </FormField>
          </FieldListItem>

          <FieldListItem isRequired label='Data de início'>
            <FormField name='beginDate'>
              <Input type='date' />
            </FormField>
          </FieldListItem>

          <FieldListItem isRequired label='Data de fim'>
            <FormField name='endDate'>
              <Input type='date' />
            </FormField>
          </FieldListItem>
        </FieldList>
      </Card>

      <Card>
        <FormFieldArray name='questions' keyName='key'>
          {(questions, { append, remove, move }) => (
            <DimensionDataTabs>
              {dimension => (
                <ModalController
                  modal={
                    <QuestionPickModal
                      onPick={append}
                      exclude={questions}
                      filter={{ dimension: { id: dimension.id } }}
                    />
                  }>
                  {({ open }) => (
                    <VStack align='stretch'>
                      <QuestionListGroup
                        mb={3}
                        isMovable={true}
                        onMove={move}
                        placeholder='Não existem questōes nesta dimensão'>
                        {questions.map(
                          (question, index) =>
                            question.dimension.id === dimension.id && (
                              <QuestionListGroupItem
                                id={question.id}
                                key={question.key}
                                question={question}
                                actions={
                                  <IconButton
                                    // size='xs'
                                    height='100%'
                                    borderRadius='0'
                                    variant='ghost'
                                    colorScheme='red'
                                    aria-label='Remover'
                                    onClick={() => remove(index)}
                                    icon={<DeleteIcon />}
                                  />
                                }>
                                <FormField
                                  defaultValue={question.id}
                                  name={`questions[${index}].id`}
                                  render={<input type='hidden' />}
                                />
                              </QuestionListGroupItem>
                            )
                        )}
                      </QuestionListGroup>
                      <Button onClick={open}>Adicionar questão</Button>
                    </VStack>
                  )}
                </ModalController>
              )}
            </DimensionDataTabs>
          )}
        </FormFieldArray>
      </Card>
    </VStack>
  </Form>
))

export default FormEditForm
